import { AccountFeatures } from "@enums/account/AccountFeature";
import { NavigationService } from "@services/navigation.service";
import { TranslationService } from "@services/translation.service";
import { StateProvider, UIRouter, UrlRouterProvider } from "@uirouter/angularjs";
import { StickyStatesPlugin } from "@uirouter/sticky-states";
import * as angular from "angular";
import { PageStateNames } from "./class/PageStateNames";
import { FleetNavigationModule } from "./main/modules/fleet/fleet.navigation";
import { AuthorizationService } from "./services/authorization.service";

export class RouteConfig {

    static $inject = ["$stateProvider", "$urlRouterProvider", "$locationProvider", "$uiRouterProvider", "isMobile"];

    // Todo: tidy up ui router
    constructor(
        $stateProvider: StateProvider,
        $urlRouterProvider: UrlRouterProvider,
        $locationProvider: angular.ILocationProvider,
        $uiRouterProvider: UIRouter,
        isMobile: boolean
    ) {

        $uiRouterProvider.plugin(StickyStatesPlugin);
        $locationProvider.html5Mode(true);

        //if (isMobile) {
        //    PageStateNames.DEFAULT_PAGE = FleetModule.Default;
        //}

        //this._urlRouterProvider.otherwise("/pages/auth/login");
        //this._urlRouterProvider.otherwise(PageStateNames.DEFAULTPAGE);

        ($urlRouterProvider as any).otherwise(($injector) => {
            //var $state = $injector.get("$state");
            //console.log("$state", $state);
            var navigationService: NavigationService = $injector.get("navigationService");

            navigationService.goToDefaultPage();
        });

        let layoutHtml = isMobile
            ? require("./layouts/mobile.html")
            : require("./layouts/default.html");

        //if (window["horizontalNavTest"]) {
        //    layoutHtml = require("./layouts/horizontal-nav-test.html");
        //    $("body").addClass("module-test");
        //}

        $stateProvider.state("app", {
            abstract: true,
            views: {
                "main@": {
                    template: layoutHtml
                }
            },
            resolve: {
                authorize: ["authorizationService", (authorization: AuthorizationService) => authorization.authorize()],
                translations: ["translationService", (translationService: TranslationService) => translationService.initialise()]
            }
        });

        $stateProvider.state(PageStateNames.AUTHORIZATION_UNAUTHORIZED, {
            url: "/unauthorized",
            views: {
                "module-navigation": { component: "unauthorizedView" }
            },
            data: { settings: { displayName: 'Unauthorized' }, translation: 'Common.Unauthorized' },
            resolve: {
                authorize: ["authorizationService", (authorization: AuthorizationService) => authorization.isUserUnauthorized()]
            }
        });

        $stateProvider.state(FleetNavigationModule.ParentRoot, {
            abstract: true,
            url: "/fleet",
            redirectTo: FleetNavigationModule.Default,
            views: {
                "module-navigation": {
                    component: "fleetModuleNavigation"
                }
            },
            data: { translation: 'Common.Fleet' },
            resolve: {
                authorize: ["authorizationService", (authorization: AuthorizationService) => authorization.authorizeForUser([],
                    [
                        AccountFeatures.Breathalock,
                        AccountFeatures.Messaging,
                        AccountFeatures.Tacho,
                        AccountFeatures.Temperature,
                        AccountFeatures.TrackingDevice
                    ])]
            }
        })

        //$stateProvider.state("app.cameras", {
        //    abstract: true,
        //    url: "/cameras",
        //    views: {
        //        "module-navigation": {
        //            component: "cameraModuleNavigation"
        //        }
        //    }
        //})

        $stateProvider.state("app.tms.old", {
            abstract: true,
            url: "/tms-old",
            views: {
                "module-navigation": {
                    //component: "tmsModuleNavigation"
                }
            }
        })
    }
}
